import { render, staticRenderFns } from "./editstockcompare.vue?vue&type=template&id=65dda76c"
import script from "./editstockcompare.vue?vue&type=script&lang=js"
export * from "./editstockcompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports